
export const zh = {
  "demo.main.logoText": "你的AI广告助手",
  "demo.main.welcomeText": "你好，我能为你做什么？",
  "demo.main.scrollToBottom": "滚动页面到底部",
  "demo.menu.createNewDialog.cannotCreateInMode": "当前模式下无法新建对话",
  "demo.menu.createNewDialog.title": "新建对话",
  "demo.menu.createNewDialog.content": "当前对话内容将被保存至历史，是否确认开启新对话？",
  "demo.menu.createNewDialog.confirm": "确认",
  "demo.menu.createNewDialog.cancel": "取消",
  "demo.menu.createNewDialog.success": "新对话已创建",
  "demo.menu.createNewDialog.error": "创建新对话失败",
  "demo.menu.historyMode.cannotSwitch": "当前模式下不可切换到历史记录",
  "demo.menu.newConversationButton": "+ 新建对话",
  "demo.menu.historicalDialogue": "历史对话",
  "demo.menu.untitledConversation": "未命名对话",
  "demo.menu.emptyHistory": "暂无历史对话",
  "demo.menu.videoDatabase": "我的视频库",
  "demo.videoLibrary.loadFailed": "加载失败",
  "demo.videoLibrary.noVideoToDownload": "暂无视频可下载",
  "demo.videoLibrary.downloadSuccess": "下载成功",
  "demo.videoLibrary.downloadOpenInNewTab": "已在新标签页打开视频",
  "demo.videoLibrary.title": "我的视频库",
  "demo.videoLibrary.subtitle": "所有历史生成的AI视频创意素材",
  "demo.videoLibrary.noData": "暂无视频数据",
  "demo.videoLibrary.filterCompleted": "已完成",
  "demo.videoLibrary.filterGenerating": "生成中",
  "demo.videoLibrary.filterFailed": "失败",
  "demo.videoLibrary.detailVideoInfo": "视频信息",
  "demo.videoLibrary.detailStatus": "状态",
  "demo.videoLibrary.detailDuration": "时长",
  "demo.videoLibrary.detailSize": "尺寸",
  "demo.videoLibrary.detailCreatedAt": "创建时间",
  "demo.videoLibrary.detailFailReason": "失败原因",
  "demo.videoLibrary.detailScriptPrompt": "脚本 / Prompt",
  "demo.videoLibrary.downloadVideo": "下载视频",
  "demo.videoLibrary.backToLibrary": "返回视频库",
  "demo.videoStoryboard.remakeSuccess": "操作成功",
  "demo.videoStoryboard.remake": "重制",
  "demo.think.generating": "生成中...",
  "demo.think.completedThought": "已完成思考。",
  "demo.think.viewMore": "查看更多",
  "demo.think.viewLess": "收起",
  "demo.sender.pleaseExitHistoryMode": "请先退出历史记录模式",
  "demo.sender.clearInput": "清空输入",
  "demo.sender.generating": "生成中",
  "system.head.logout": "退出登录",
  "system.login_expired_tips": "登录已过期，请重新登录",
  "login.title": "欢迎回来",
  "login.account": "账号",
  "login.account_placeholder": "请输入账号或手机号",
  "login.account_required": "请输入账号",
  "login.password": "密码",
  "login.password_placeholder": "请输入密码",
  "login.password_required": "请输入密码",
  "login.submit": "登录",
  "login.success": "登录成功",
  "login.failed": "登录失败，请稍后重试",
  "const.server_error_tips": "服务异常，请稍后再试",
  "upload.file_type_limit.tips": "图片格式必须为 {str} 类型",
  "upload.limit.size.tps": "图片必须小于 {size}MB，请压缩后再上传",
  "upload.upload_failed": "上传失败",
  "upload.upload_success": "上传成功",
  "check_app_version.tips": "当前系统功能有更新迭代，点击将刷新页面加载到最新版本",
  "check_app_version.refresh_btn": "点击刷新页面"
} 
export const th = {
  "demo.main.logoText": "Your AI advertising assistant",
  "demo.main.welcomeText": "Hello, how can I help you?",
  "demo.main.scrollToBottom": "Scroll to bottom",
  "demo.menu.createNewDialog.cannotCreateInMode": "Cannot create new conversation in current mode",
  "demo.menu.createNewDialog.title": "New Conversation",
  "demo.menu.createNewDialog.content": "Current conversation will be saved to history. Are you sure you want to start a new conversation?",
  "demo.menu.createNewDialog.confirm": "Confirm",
  "demo.menu.createNewDialog.cancel": "Cancel",
  "demo.menu.createNewDialog.success": "New conversation created",
  "demo.menu.createNewDialog.error": "Failed to create new conversation",
  "demo.menu.historyMode.cannotSwitch": "Cannot switch to history in current mode",
  "demo.menu.newConversationButton": "+ New Conversation",
  "demo.menu.historicalDialogue": "Historical Dialogue",
  "demo.menu.untitledConversation": "Untitled Conversation",
  "demo.menu.emptyHistory": "No historical conversations",
  "demo.menu.videoDatabase": "My Video Library",
  "demo.videoLibrary.loadFailed": "Load failed",
  "demo.videoLibrary.noVideoToDownload": "No video to download",
  "demo.videoLibrary.downloadSuccess": "Download successful",
  "demo.videoLibrary.downloadOpenInNewTab": "Video opened in new tab",
  "demo.videoLibrary.title": "My Video Library",
  "demo.videoLibrary.subtitle": "All historically generated AI video creative materials",
  "demo.videoLibrary.noData": "No video data",
  "demo.videoLibrary.filterCompleted": "Completed",
  "demo.videoLibrary.filterGenerating": "Generating",
  "demo.videoLibrary.filterFailed": "Failed",
  "demo.videoLibrary.detailVideoInfo": "Video information",
  "demo.videoLibrary.detailStatus": "Status",
  "demo.videoLibrary.detailDuration": "Duration",
  "demo.videoLibrary.detailSize": "Size",
  "demo.videoLibrary.detailCreatedAt": "Created at",
  "demo.videoLibrary.detailFailReason": "Fail reason",
  "demo.videoLibrary.detailScriptPrompt": "Script / Prompt",
  "demo.videoLibrary.downloadVideo": "Download video",
  "demo.videoLibrary.backToLibrary": "Back to library",
  "demo.videoStoryboard.remakeSuccess": "Operation successful",
  "demo.videoStoryboard.remake": "Remake",
  "demo.think.generating": "Generating...",
  "demo.think.completedThought": "Completed Thought.",
  "demo.think.viewMore": "View more",
  "demo.think.viewLess": "View less",
  "demo.sender.pleaseExitHistoryMode": "Please exit history mode first",
  "demo.sender.clearInput": "Clear input",
  "demo.sender.generating": "Generating",
  "system.head.logout": "Log out",
  "system.login_expired_tips": "Login expired, please sign in again",
  "login.title": "Welcome back",
  "login.account": "Account",
  "login.account_placeholder": "Account or phone number",
  "login.account_required": "Please enter your account",
  "login.password": "Password",
  "login.password_placeholder": "Enter your password",
  "login.password_required": "Please enter your password",
  "login.submit": "Sign in",
  "login.success": "Signed in successfully",
  "login.failed": "Sign in failed, please try again",
  "const.server_error_tips": "Service error. Please try again later",
  "upload.file_type_limit.tips": "Image format must be {str}",
  "upload.limit.size.tps": "Image must be smaller than {size}MB",
  "upload.upload_failed": "Upload failed",
  "upload.upload_success": "Upload successful"
} 
export const ms = {
  "demo.main.logoText": "Your AI advertising assistant",
  "demo.main.welcomeText": "Hello, how can I help you?",
  "demo.main.scrollToBottom": "Scroll to bottom",
  "demo.menu.createNewDialog.cannotCreateInMode": "Cannot create new conversation in current mode",
  "demo.menu.createNewDialog.title": "New Conversation",
  "demo.menu.createNewDialog.content": "Current conversation will be saved to history. Are you sure you want to start a new conversation?",
  "demo.menu.createNewDialog.confirm": "Confirm",
  "demo.menu.createNewDialog.cancel": "Cancel",
  "demo.menu.createNewDialog.success": "New conversation created",
  "demo.menu.createNewDialog.error": "Failed to create new conversation",
  "demo.menu.historyMode.cannotSwitch": "Cannot switch to history in current mode",
  "demo.menu.newConversationButton": "+ New Conversation",
  "demo.menu.historicalDialogue": "Historical Dialogue",
  "demo.menu.untitledConversation": "Untitled Conversation",
  "demo.menu.emptyHistory": "No historical conversations",
  "demo.menu.videoDatabase": "My Video Library",
  "demo.videoLibrary.loadFailed": "Load failed",
  "demo.videoLibrary.noVideoToDownload": "No video to download",
  "demo.videoLibrary.downloadSuccess": "Download successful",
  "demo.videoLibrary.downloadOpenInNewTab": "Video opened in new tab",
  "demo.videoLibrary.title": "My Video Library",
  "demo.videoLibrary.subtitle": "All historically generated AI video creative materials",
  "demo.videoLibrary.noData": "No video data",
  "demo.videoLibrary.filterCompleted": "Completed",
  "demo.videoLibrary.filterGenerating": "Generating",
  "demo.videoLibrary.filterFailed": "Failed",
  "demo.videoLibrary.detailVideoInfo": "Video information",
  "demo.videoLibrary.detailStatus": "Status",
  "demo.videoLibrary.detailDuration": "Duration",
  "demo.videoLibrary.detailSize": "Size",
  "demo.videoLibrary.detailCreatedAt": "Created at",
  "demo.videoLibrary.detailFailReason": "Fail reason",
  "demo.videoLibrary.detailScriptPrompt": "Script / Prompt",
  "demo.videoLibrary.downloadVideo": "Download video",
  "demo.videoLibrary.backToLibrary": "Back to library",
  "demo.videoStoryboard.remakeSuccess": "Operation successful",
  "demo.videoStoryboard.remake": "Remake",
  "demo.think.generating": "Generating...",
  "demo.think.completedThought": "Completed Thought.",
  "demo.think.viewMore": "View more",
  "demo.think.viewLess": "View less",
  "demo.sender.pleaseExitHistoryMode": "Please exit history mode first",
  "demo.sender.clearInput": "Clear input",
  "demo.sender.generating": "Generating",
  "system.head.logout": "Log Keluar",
  "system.login_expired_tips": "Sesi Log Masuk Tamat Tempoh, Sila Log Masuk Semula",
  "login.title": "Selamat kembali",
  "login.account": "Akaun",
  "login.account_placeholder": "Akaun atau nombor telefon",
  "login.account_required": "Sila masukkan akaun",
  "login.password": "Kata laluan",
  "login.password_placeholder": "Sila masukkan kata laluan",
  "login.password_required": "Sila masukkan kata laluan",
  "login.submit": "Log masuk",
  "login.success": "Log masuk berjaya",
  "login.failed": "Log masuk gagal, sila cuba lagi",
  "const.server_error_tips": "Ralat perkhidmatan, sila cuba lagi kemudian.",
  "upload.file_type_limit.tips": "Format gambar mesti jenis {str}!",
  "upload.limit.size.tps": "Gambar mesti kurang daripada {size}MB, sila mampatkan sebelum memuat naik.",
  "upload.upload_failed": "Muat naik gagal",
  "upload.upload_success": "Muat naik berjaya"
} 
export const en = {
  "demo.main.logoText": "Your AI advertising assistant",
  "demo.main.welcomeText": "Hello, how can I help you?",
  "demo.main.scrollToBottom": "Scroll to bottom",
  "demo.menu.createNewDialog.cannotCreateInMode": "Cannot create new conversation in current mode",
  "demo.menu.createNewDialog.title": "New Conversation",
  "demo.menu.createNewDialog.content": "Current conversation will be saved to history. Are you sure you want to start a new conversation?",
  "demo.menu.createNewDialog.confirm": "Confirm",
  "demo.menu.createNewDialog.cancel": "Cancel",
  "demo.menu.createNewDialog.success": "New conversation created",
  "demo.menu.createNewDialog.error": "Failed to create new conversation",
  "demo.menu.historyMode.cannotSwitch": "Cannot switch to history in current mode",
  "demo.menu.newConversationButton": "+ New Conversation",
  "demo.menu.historicalDialogue": "Historical Dialogue",
  "demo.menu.untitledConversation": "Untitled Conversation",
  "demo.menu.emptyHistory": "No historical conversations",
  "demo.menu.videoDatabase": "My Video Library",
  "demo.videoLibrary.loadFailed": "Load failed",
  "demo.videoLibrary.noVideoToDownload": "No video to download",
  "demo.videoLibrary.downloadSuccess": "Download successful",
  "demo.videoLibrary.downloadOpenInNewTab": "Video opened in new tab",
  "demo.videoLibrary.title": "My Video Library",
  "demo.videoLibrary.subtitle": "All historically generated AI video creative materials",
  "demo.videoLibrary.noData": "No video data",
  "demo.videoLibrary.filterCompleted": "Completed",
  "demo.videoLibrary.filterGenerating": "Generating",
  "demo.videoLibrary.filterFailed": "Failed",
  "demo.videoLibrary.detailVideoInfo": "Video information",
  "demo.videoLibrary.detailStatus": "Status",
  "demo.videoLibrary.detailDuration": "Duration",
  "demo.videoLibrary.detailSize": "Size",
  "demo.videoLibrary.detailCreatedAt": "Created at",
  "demo.videoLibrary.detailFailReason": "Fail reason",
  "demo.videoLibrary.detailScriptPrompt": "Script / Prompt",
  "demo.videoLibrary.downloadVideo": "Download video",
  "demo.videoLibrary.backToLibrary": "Back to library",
  "demo.videoStoryboard.remakeSuccess": "Operation successful",
  "demo.videoStoryboard.remake": "Remake",
  "demo.think.generating": "Generating...",
  "demo.think.completedThought": "Completed Thought.",
  "demo.think.viewMore": "View more",
  "demo.think.viewLess": "View less",
  "demo.sender.pleaseExitHistoryMode": "Please exit history mode first",
  "demo.sender.clearInput": "Clear input",
  "demo.sender.generating": "Generating",
  "system.head.logout": "Log out",
  "system.login_expired_tips": "Login expired, please sign in again",
  "login.title": "Welcome back",
  "login.account": "Account",
  "login.account_placeholder": "Account or phone number",
  "login.account_required": "Please enter your account",
  "login.password": "Password",
  "login.password_placeholder": "Enter your password",
  "login.password_required": "Please enter your password",
  "login.submit": "Sign in",
  "login.success": "Signed in successfully",
  "login.failed": "Sign in failed, please try again",
  "const.server_error_tips": "Service error. Please try again later",
  "upload.file_type_limit.tips": "Image format must be {str}",
  "upload.limit.size.tps": "Image must be smaller than {size}MB",
  "upload.upload_failed": "Upload failed",
  "upload.upload_success": "Upload successful"
} 

export const allLocales = {
    zh,
  th,
  ms,
  en
}


// 默认导出所有语言包
export default allLocales
  